// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbac-onboarding-wrapper {
  padding: 32px 40px;
  max-width: 720px;
}

.rbac-onboarding-heading {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 6px;
}

.rbac-onboarding-subheading {
  font-size: 14px;
  color: #666;
  margin-bottom: 28px;
}

.rbac-onboarding-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 28px 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.rbac-onboarding-card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.rbac-onboarding-label {
  font-size: 14px;
  font-weight: 500;
  color: #444;
  margin-bottom: 6px;
  display: block;
}

.rbac-onboarding-input {
  font-size: 14px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #d0d0d0;
  padding: 0 12px;
  width: 100%;
  outline: none;
  transition: border-color 0.2s;
}

.rbac-onboarding-input.input-error {
  border-color: #e53935;
}

.rbac-onboarding-error-text {
  font-size: 12px;
  color: #e53935;
  margin-top: 5px;
  display: block;
}

.rbac-onboarding-help-text {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
  display: block;
}

.rbac-onboarding-submit-btn {
  margin-top: 20px;
  padding: 9px 28px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./client/components/rbacOnboarding/rbacOnboarding.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".rbac-onboarding-wrapper {\n  padding: 32px 40px;\n  max-width: 720px;\n}\n\n.rbac-onboarding-heading {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin-bottom: 6px;\n}\n\n.rbac-onboarding-subheading {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 28px;\n}\n\n.rbac-onboarding-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 28px 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.rbac-onboarding-card-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.rbac-onboarding-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #444;\n  margin-bottom: 6px;\n  display: block;\n}\n\n.rbac-onboarding-input {\n  font-size: 14px;\n  height: 40px;\n  border-radius: 6px;\n  border: 1px solid #d0d0d0;\n  padding: 0 12px;\n  width: 100%;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.rbac-onboarding-input.input-error {\n  border-color: #e53935;\n}\n\n.rbac-onboarding-error-text {\n  font-size: 12px;\n  color: #e53935;\n  margin-top: 5px;\n  display: block;\n}\n\n.rbac-onboarding-help-text {\n  font-size: 12px;\n  color: #999;\n  margin-top: 6px;\n  display: block;\n}\n\n.rbac-onboarding-submit-btn {\n  margin-top: 20px;\n  padding: 9px 28px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
